(function () {
  'use strict';
  angular
    .module('garanteasyApp')
    .factory('Merchant', Merchant);

  Merchant.$inject = ['$resource', 'API_URI'];

  function Merchant($resource, API_URI) {
    var resourceUrl = API_URI + 'api/merchants/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true},
      'get': {
        method: 'GET',
        transformResponse: function (data) {
          if (data) {
            data = angular.fromJson(data);
          }
          return data;
        }
      },
      'update': {method: 'PUT'}
    });
  }
})();
